/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<ObjectMap>;
export function request(
  body: defs.tms.LogisticsChannelTobRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelTob/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
